import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/function-call.js";
import { a as e } from "../internals/an-object.js";
import { i as o } from "../internals/is-object.js";
import { i } from "../internals/is-data-descriptor.js";
import { f as s } from "../internals/fails.js";
import "../internals/object-define-property.js";
import "../internals/object-get-own-property-descriptor.js";
import { o as n } from "../internals/object-get-prototype-of.js";
import { c as a } from "../internals/create-property-descriptor.js";
import { __exports as f } from "../../../_virtual/object-define-property.js";
import { __exports as p } from "../../../_virtual/object-get-own-property-descriptor.js";
r({
  target: "Reflect",
  stat: !0,
  forced: s(function () {
    var r = function r() {},
      t = f.f(new r(), "a", {
        configurable: !0
      });
    return !1 !== Reflect.set(r.prototype, "a", 1, t);
  })
}, {
  set: function r(s, l, c) {
    var m,
      j,
      u,
      b = arguments.length < 4 ? s : arguments[3],
      d = p.f(e(s), l);
    if (!d) {
      if (o(j = n(s))) return r(j, l, c, b);
      d = a(0);
    }
    if (i(d)) {
      if (!1 === d.writable || !o(b)) return !1;
      if (m = p.f(b, l)) {
        if (m.get || m.set || !1 === m.writable) return !1;
        m.value = c, f.f(b, l, m);
      } else f.f(b, l, a(0, c));
    } else {
      if (void 0 === (u = d.set)) return !1;
      t(u, b, c);
    }
    return !0;
  }
});